module.exports = __webpack_public_path__ + "static/media/EmpowermentLounge.9f101f2b.png";